import React, { useState } from 'react';
import { Field, Form, Formik } from 'formik';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { PhoneNumberInputModern, validators } from '../../../app/components/Form';
import normalizePhoneNumber from '../../../app/components/Form/PhoneNumberInput/normalizePhoneNumber';
// import format from '../../../app/components/Form/PhoneNumberInput/format';
import Notifications from '../../../app/components/Notifications/Notifications';
import { Endpoints } from '../../../app/lib/LeanLinkService';
import Header from '../../Router/Header';
import InputModern from '../../../app/components/Form/InputModern';
import Routes from '../../Router/Routes';
import * as SessionActions from '../../../app/entities/Session/actions';
import { success } from '../../../app/lib/Actions';
import { useTranslation } from 'react-i18next';

const styles = {
  submitPhone: {
    marginTop: '10px',
  },

  submitCode: {
    marginTop: '10px',
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
  },
};

const MissingBankId = ({ handleSubmit, twoFactorAuth }) => {
  const { t } = useTranslation()
  const [isCodeInputVisible, setIsCodeInputVisible] = useState(false);
  const history = useHistory();

  const createCode = async (phoneNumber) => {
    const settings = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ phoneNumber }),
    };

    try {
      const codes = await fetch(Endpoints.public.createLoginCode(), settings);
      const returningData = await codes.json();
      if (returningData) {
        return returningData;
      }
    } catch (error) {
      if (!error) return null;
      return error;
    }
  };

  const createToken = async (phoneNumber, code) => {
    const settings = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ phoneNumber, code }),
    };

    try {
      const codes = await fetch(Endpoints.public.createLoginToken(), settings);
      const returningData = await codes.json();
      if (returningData) {
        return returningData;
      }
    } catch (error) {
      if (!error) return null;
      return error;
    }
  };

  const handlePhoneSubmit = async (form) => {
    const { phoneNumber } = form.values;
    const code = await createCode(phoneNumber);
    if (!code.errors) {
      setIsCodeInputVisible(true);
    } else {
      form.setErrors({ phoneNumber: code.errors });
      setIsCodeInputVisible(false);
    }
  };

  const handleSmsCodeSubmit = async (form) => {
    const { phoneNumber, code } = form.values;
    const tokenPayload = await createToken(phoneNumber, code);
    const { token } = tokenPayload;
    if (!tokenPayload.errors) {
      twoFactorAuth({ token });
      history.push(Routes.home());
    } else {
      form.setErrors({ code: tokenPayload.errors });
    }
  };

  return (
    <div>
      <Header />
      <div className="container-fluid">
        <Notifications />
        <div className="row">
          <div className="col-md-3 col-md-offset-5">
            <p>
              {t("Just nu krävs BankID för inloggning till portalen.")}
              {t("Saknar du personnummer så kontakta din konsultchef för att gör det möjligt")}
              {t(" att logga in med engångskoder som skickas med sms.")}
            </p>
            <div>
              <Formik
                initialValues={() => { }}
                validate={validators.phoneNumber}
                onSubmit={() => { }}
              >
                {(formProps) => (
                  <Form>
                    <div style={styles.container}>
                      <Field
                        id="phoneNumber"
                        name="phoneNumber"
                        label={t("Telefonnummer")}
                        component={PhoneNumberInputModern}
                        showSubmitMsg={isCodeInputVisible}
                        normalize={normalizePhoneNumber}
                      />
                      <Button
                        stretch
                        style={styles.submitPhone}
                        variant="primary"
                        onClick={() => handlePhoneSubmit(formProps)}
                      >
                        {t("Submit")}
                      </Button>
                    </div>
                    {isCodeInputVisible && (
                      <div style={styles.container}>
                        <Field
                          label={t("Code")}
                          name="code"
                          component={InputModern}
                        />
                        <Button
                          stretch
                          style={styles.submitCode}
                          type="submit"
                          variant="success"
                          onClick={() => handleSmsCodeSubmit(formProps)}
                        >
                          {t("Submit code")}
                        </Button>
                      </div>
                    )}
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

MissingBankId.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  twoFactorAuth: PropTypes.func.isRequired,
};

export default connect(null, {
  twoFactorAuth: success(SessionActions.TWO_FACTOR_AUTH),
})(MissingBankId);
